import React, { Fragment, useCallback } from 'react';
import { useTranslation } from 'localization/useTranslation';
// import { Tooltip } from '@patternfly/react-core';
import { DateTime } from 'luxon';
import { v4 } from 'uuid';

export const TIME_VIEW = Object.freeze({
  relative: 'relative',
  full: 'full',
  short: 'short',
  date: 'date',
  time: 'time',
  utc: 'utc'
});


const TimeView = ({ value, viewType = TIME_VIEW.relative }) => {
  const T = useTranslation();
  const parsedTime = DateTime.fromISO(value);
  const never = parsedTime.plus({ years: 10 });
  const now = DateTime.now();

  const renderFormat = useCallback((time, type) => {
    switch (type) {
      case TIME_VIEW.full:
        return time.toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS);
      case TIME_VIEW.date:
        return time.toLocaleString(DateTime.DATETIME_MED);
      case TIME_VIEW.time:
        return time.toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      case TIME_VIEW.relative:
        return time.toRelative();
      case TIME_VIEW.short:
      default:
        return time.toLocaleString(DateTime.DATETIME_SHORT);
    }
  }, []);

  return (
    <Fragment key={v4()}>
      { /* <Tooltip
        content={parsedTime.toLocaleString(DateTime.DATETIME_SHORT)}
      > */ }
      { (never > now) ? renderFormat(parsedTime, viewType) : T.common.never }
      { /* </Tooltip> */ }
    </Fragment>
  );

};

export default TimeView;
